import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Box, Button, Fade, Flex, Text } from '@brand/components';
import { LocalStorage } from 'enums/localStorage';

export const CookieBanner = (): JSX.Element => {
  const { t } = useTranslation(['common']);

  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    const hasAcceptedCookies = localStorage.getItem(
      LocalStorage.COOKIE_STORAGE_ID,
    );

    setIsVisible(!hasAcceptedCookies);
  }, []);

  const handleClickConfigure = () => {
    setIsVisible(false);
    localStorage.setItem(LocalStorage.COOKIE_STORAGE_ID, `false`);
  };

  const onCookieBannerClose = () => {
    setIsVisible(false);
    localStorage.setItem(LocalStorage.COOKIE_STORAGE_ID, `true`);
  };

  const handleCloseClick = () => {
    setIsVisible(false);
    onCookieBannerClose();
  };

  return (
    <Fade in={isVisible} unmountOnExit>
      <Flex
        alignItems="center"
        as="aside"
        bg="#f3f5f9"
        bottom={0}
        boxShadow="lg"
        color="#405a6b"
        direction={[`column`, null, null, `row`]}
        justifyContent="space-around"
        left={0}
        minHeight={5}
        padding={5}
        position="fixed"
        width="100vw"
        zIndex="10"
      >
        <Box>
          <Text size="sm">
            {t(`common:cookies.text`)}
            <a
              href={t(`common:cookies.url`)}
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}
              target="_blank"
            >
              {t(`common:cookies.policy`)}
            </a>
          </Text>
        </Box>
        <Box>
          <Flex
            direction={[`row`, null, null, `column`, `row`]}
            justifyContent="space-between"
          >
            <Button
              data-test-id="cookie-banner-btn-configure"
              m="1"
              onClick={handleClickConfigure}
              size="xs"
              type="button"
              variant="outlineBlue"
              width="125px"
            >
              {t(`common:generic.deny`)}
            </Button>
            <Button
              data-test-id="cookie-banner-btn-ok"
              m="1"
              onClick={handleCloseClick}
              size="xs"
              type="button"
              variant="solid"
              width="125px"
            >
              {t(`common:generic.accept`)}
            </Button>
          </Flex>
        </Box>
      </Flex>
    </Fade>
  );
};
